import isEqual from "lodash.isequal";
import { useState } from "react";

import type { ISortOption, ISortOrderValue } from "@/lib/types/centra";
import { useTranslations } from "next-intl";

export const useSortOrder = () => {
  const [sortOrder, setSortOrder] = useState<ISortOrderValue[]>([]);

  const t = useTranslations();

  const modifySortOrder = (value: ISortOrderValue[]) => {
    setSortOrder(value);
  };

  const options: ISortOption[] = [
    {
      key: "default",
      display: t("modal.sortBy.default"),
      value: [],
      setFunction: () => modifySortOrder([]),
      active: isEqual(sortOrder, [])
    },
    {
      key: "nameAsc",
      display: t("modal.sortBy.nameAsc"),
      value: [{ field: "categoryItemSort", order: "asc" }],
      setFunction: () =>
        modifySortOrder([{ field: "categoryItemSort", order: "asc" }]),
      active: isEqual(sortOrder, [{ field: "categoryItemSort", order: "asc" }])
    },
    {
      key: "nameDesc",
      display: t("modal.sortBy.nameDesc"),
      value: [{ field: "categoryItemSort", order: "desc" }],
      setFunction: () =>
        modifySortOrder([{ field: "categoryItemSort", order: "desc" }]),
      active: isEqual(sortOrder, [{ field: "categoryItemSort", order: "desc" }])
    },

    {
      key: "lowestPrice",
      display: t("modal.sortBy.lowestPrice"),
      value: [{ field: "priceAsNumber", order: "asc" }],
      setFunction: () =>
        modifySortOrder([{ field: "priceAsNumber", order: "asc" }]),
      active: isEqual(sortOrder, [{ field: "priceAsNumber", order: "asc" }])
    },
    {
      key: "highestPrice",
      display: t("modal.sortBy.highestPrice"),
      value: [{ field: "priceAsNumber", order: "desc" }],
      setFunction: () =>
        modifySortOrder([{ field: "priceAsNumber", order: "desc" }]),
      active: isEqual(sortOrder, [{ field: "priceAsNumber", order: "desc" }])
    },
    {
      key: "newest",
      display: t("modal.sortBy.newest"),
      value: [{ field: "createdAt", order: "desc" }],
      setFunction: () =>
        modifySortOrder([{ field: "createdAt", order: "desc" }]),
      active: isEqual(sortOrder, [{ field: "createdAt", order: "desc" }])
    }
  ];

  const active = options.find((option) => option.active);

  return {
    setSortOrder,
    sortOrder,
    options,
    active
  };
};

export type SortOrder = ReturnType<typeof useSortOrder>;
